module.exports = __webpack_public_path__ + "img/zu1.b37e4a9c.png";